import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@vr/lib';
import cnpjValidate from '@vr/devkit/validators/cnpjValidate';
import clearNotNumber from '@vr/devkit/utils/clearNotNumber';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { MaskField } from '~/elements';
import getErrorMsg from '~/helpers/errorMessages';
import {
  updateField,
  searchCnpj,
  setTipoIndicacao,
} from '~/store/modules/indicacao/actions';

const ButtonIcon = styled.button`
  border: none;
  background: transparent;
  position: absolute;
  right: 0;
  top: 22px;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray400};
  cursor: pointer;
`;

const Form = styled.form`
  margin-bottom: 20px;

  .MuiInputBase-input,
  .MuiInputLabel-root {
    color: ${({ theme }) => theme.colors.gray400} !important;
  }
`;
const Content = styled.div`
  position: relative;
  max-width: 335px;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) => theme.colors.gray300};
    caret-color: ${({ theme }) => theme.colors.gray300};
  }
`;

function FormBuscaCNPJ() {
  const { errors, watch, formState, handleSubmit, ...formControl } = useForm({
    mode: 'onChange',
  });
  const dispatch = useDispatch();
  const history = useHistory();

  const cnpj = useSelector(state => state.indicacao.cnpj);

  useEffect(() => {
    dispatch(setTipoIndicacao('cnpj'));
  }, [dispatch]);

  useEffect(() => {
    const value = watch('cnpj');
    dispatch(updateField('cnpj', value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch('cnpj')]);

  const onSubmit = useCallback(
    () => {
      if (formState.isValid) {
        dispatch(searchCnpj(clearNotNumber(cnpj)));
        history.push('/indique/formulario');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, cnpj],
  );

  return (
    <Form id="form-busca-cnpj" onSubmit={handleSubmit(onSubmit)} noValidate>
      <Content>
        <MaskField
          fullWidth
          label="Informe o número do CNPJ"
          name="cnpj"
          mask="99.999.999/9999-99"
          type="tel"
          rules={{
            minLength: 18, // 18 pois está contando todos os caracteres
            validate: val => {
              return cnpjValidate(val);
            },
          }}
          formControl={formControl}
          error={!!errors.cnpj}
          caption={getErrorMsg(errors, 'cnpj')}
        />
        <ButtonIcon type="submit">
          <FontAwesomeIcon icon={['far', 'search']} />
        </ButtonIcon>
      </Content>
    </Form>
  );
}

export default FormBuscaCNPJ;
